import React from 'react';
import Event2Main from '../../Data/Assets/images/Event2Main.jpg';
import Event21 from '../../Data/Assets/images/Event21.jpg';
import Event22 from '../../Data/Assets/images/Event22.jpg';
import Event23 from '../../Data/Assets/images/Event23.jpg';
import './event2.css';
import Navbar from '../home_page/navbar';
import Footer from '../home_page/footer';
function EventTwo() {
  return (
    <div>
      <Navbar />
      <div id="event">
        <div id="event-2-title">IYNS at Gastech, Milan Italy</div>
        <div id="image-gallery">
          <div id="big-image">
            <img src={Event2Main} alt={'IYNS at Gastech'} />
          </div>
          <div id="image-row">
            <div id="image-row-container">
              <img className="small_img" src={Event21} alt={'Gastech Event 1'} />
              <img className="small_img" src={Event22} alt={'Gastech Event 2'} />
              <img className="small_img" src={Event23} alt={'Gastech Event 3'} />
            </div>
          </div>
          <div id="page-content">
            <p>
              Leaders don't see the future; they see the dead end of what they're doing. Still, they
              continue to solve it through innovation because it's important for humanity, said Dr.
              Nitendra Singh at the Gastech Exhibition and Conference 2025, during the session
              titled “Attracting the leaders of tomorrow, today.
            </p>
            <p>
              Gastech is the world's largest exhibition and conference for natural gas, LNG,
              hydrogen, climate technologies, and AI in energy, held this year in Milan, Italy. Dr.
              Singh was a panelist in the featured program “Future Leaders” on 11th September. Led
              by senior industry leaders, the program was designed to empower the next generation of
              energy pioneers. The discussion was intriguing and was well received by the youth.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default EventTwo;
